import { useState } from "react";
import { initializePaddle, getPaddlePriceId } from "@/lib/paddle";

export function usePaddleCheckout() {
  const [loading, setLoading] = useState(false);

  const openCheckout = async (options: {
    priceId: string;
    quantity?: number;
    customerEmail?: string;
    customData?: Record<string, string>;
    successUrl?: string;
    discountCode?: string;
    businessName?: string;
    taxId?: string;
    taxIdCountry?: string;
  }) => {
    setLoading(true);
    try {
      await initializePaddle();
      const paddlePriceId = await getPaddlePriceId(options.priceId);
      const business = options.businessName
        ? {
            name: options.businessName,
            ...(options.taxId
              ? { taxIdentifier: options.taxId, ...(options.taxIdCountry ? { country: options.taxIdCountry } : {}) }
              : {}),
          }
        : undefined;
      window.Paddle.Checkout.open({
        items: [{ priceId: paddlePriceId, quantity: options.quantity ?? 1 }],
        customer: options.customerEmail ? { email: options.customerEmail } : undefined,
        business,
        ...(options.discountCode ? { discountCode: options.discountCode } : {}),
        customData: options.customData,
        settings: {
          displayMode: "overlay",
          successUrl: options.successUrl || `${window.location.origin}/checkout/success`,
          allowLogout: false,
          variant: "one-page",
          theme: "dark",
          showAddDiscounts: true,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return { openCheckout, loading };
}